import React, { FC } from 'react'
import Dropdown from 'components/_common/Dropdown';
import { EBookType } from 'redux/app/vessel/types';

const filterOptions = [
	{
		label: EBookType.LOG.toString(),
		value: EBookType.LOG,
	},
	{
		label: EBookType.CHECKLIST.toString(),
		value: EBookType.CHECKLIST,
	},
	{
		label: EBookType.MARPOL.toString(),
		value: EBookType.MARPOL,
	}
];

interface IFilterBarProps {
	filteredBy: EBookType | null;
	setFilteredBy: (filteredBy: EBookType | null) => void;
}

const FilterBar: FC<IFilterBarProps> = (props) => {
	const { filteredBy, setFilteredBy } = props;
	return (
		<div className="relative flex items-center">
			<Dropdown
				value={filteredBy?.toString() || ''}
				placeholder="Filter"
				id="inspector-filter"
				inputWrapperProps={{
					className: 'text-xs font-medium leading-4 tracking-wide',
				}}
				style={{ width: "100%" }}
				options={filterOptions}
				onSelect={(option) => {
					if (option) {
						setFilteredBy(option.value);
					}
				}}
			/>
		</div>
	);
}

export default FilterBar;